import { useState } from "react";
import DoctorRequestHero from "../heros/DoctorRequestHero";
import DataTable from "../DataTables/DataTable";
import { useDoctorsList } from "../../hooks/doctors/useDoctorsList";
import CircularImage from "../assests/CircularImage";
import { Link } from "react-router-dom";
import { user_profile } from "../imagepath";
import { Tag } from "antd";
import { formatDateDDMMYY } from "../configs/fomatDateDDMMYY";

function RejectedDoctors() {
  const [searchTerm, setSearchterm] = useState("");
  const query = searchTerm
    ? `status=rejected&name=${searchTerm}`
    : "status=rejected";
  // const { data: doctorRequestList, isLoading } = useDoctorsList(query);

  const handelSearchTerm = (term) => {
    setSearchterm(term);
  };
  const { data: doctorList, isLoading } = useDoctorsList(query);
  const rejectedDoctors = doctorList?.filter((item) => !item?.hospital_id);

  const columns = [
    {
      title: "NAME",
      dataIndex: "name",
      key: "name",
      render: (text, record) => (
        <>
          <div className="d-flex">
            <div>
              <CircularImage
                src={record?.profile_pic ?? user_profile}
                alt={record.name}
                size={40}
                fallback={user_profile}
              />
            </div>
            <div className="ms-2 table-profile">
              <h6>{record.name}</h6>
              <p className="text-muted mb-0">{record.email}</p>
            </div>
          </div>
        </>
      ),
      sorter: (a, b) => a.name.localeCompare(b.name),
    },
    {
      title: "SPECIALISATION",
      dataIndex: "specialisations",
      // sorter: (a, b) => a.Specialization.length - b.Specialization.length,
      render: (specialisations) => (
        <div className="d-flex flex-wrap gap-2" style={{ maxWidth: "200px" }}>
          {specialisations?.map((specialisation) => (
            <Tag key={specialisation.id} color="cyan">
              {specialisation.name}
            </Tag>
          ))}
        </div>
      ),
    },
    {
      title: "MOBILE",
      dataIndex: "phone_number",
      // sorter: (a, b) => a.phone_number.length - b.phone_number.length,
      render: (text) => (
        <>
          <Link to="#">{text}</Link>
        </>
      ),
    },
    {
      title: <div className="text-center">WORK START DATE</div>,
      dataIndex: "work_start_date",
      sorter: (a, b) =>
        new Date(a.work_start_date) - new Date(b.work_start_date),
      render: (item) => (
        <div className="d-flex justify-content-center">
          {item ? formatDateDDMMYY(item) : "N/A"}
        </div>
      ),
      // sorter: (a, b) => a.JoiningDate.length - b.JoiningDate.length,
    },
    {
      title: <div className="text-center">ACTION</div>,
      dataIndex: "FIELD8",
      render: (item, record) => (
        <div className="d-flex justify-content-center">
          <Link
            to={
              record.status === "pending"
                ? `/manage-doctors/request/${record.id}`
                : `/manage-doctors/${record.id}`
            }
            className="hospital-draft-btn rounded-pill text-primary ps-3 pe-3"
          >
            {record.status === "pending" ? "Review" : "View"}
          </Link>
        </div>
      ),
    },
  ];
  return (
    <div className="row">
      <div className="col-sm-12">
        <div className="card card-table show-entire rounded-0">
          <div className="card-body">
            <DoctorRequestHero handelSearchTerm={handelSearchTerm} />
            <div className="doctor-list">
              <DataTable
                data={rejectedDoctors ?? []}
                columns={columns}
                isLoading={isLoading}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default RejectedDoctors;
